import React, { Suspense, Fragment, useState, useEffect, useRef, useContext } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { routes } from "src/routes";
import { createBrowserHistory } from "history";
import AuthContext from "src/context/Auth";
import PageLoading from "src/component/PageLoading";
import AuthGuard from "src/component/AuthGuard";
import { ThemeProvider } from "@material-ui/core";
import { createTheme } from "src/theme";
import { Toaster, useToasterStore, toast } from "react-hot-toast";
import Notification from "./Notification";
import NitificationPopUp from "src/component/NotificationAlertPopUp";
import NotificationAllow from "src/component/NotificationAllow";
import ReactDOM from "react-dom";
import UploadImageContext from "./context/UploadImage";
import CreatorModeProvider, { CreatorModeContext } from "./context/CreatorMode";
import { onMessageListener } from "./firebase";
// import dotenv from "dotenv";
// dotenv.config();

// 

const history = createBrowserHistory();

function AppContent() {
  const { isCreatorMode, setNavigationHandler } = useContext(CreatorModeContext);
  const theme = createTheme({ isDarkMode: isCreatorMode });

  // Set navigation handler for Creator Mode
  useEffect(() => {
    if (setNavigationHandler) {
      setNavigationHandler((path) => {
        history.push(path);
      });
    }
  }, [setNavigationHandler]);
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState();
  const [notificationData, setNotificationData] = useState();
  const myContainer = useRef(null);
  const [isNotificationErr, setNotificationErr] = useState(false);
  const { toasts } = useToasterStore();
  const dismissedToastIdsRef = useRef(new Set());

  useEffect(() => {
    // Dismiss any toast with no visible message to prevent blank toasts
    const dismissedIds = dismissedToastIdsRef.current;
    toasts.forEach((t) => {
      const message = t?.message;
      const hasVisibleContent =
        typeof message === "string" ? message.trim().length > 0 : !!message;
      if (!hasVisibleContent && !dismissedIds.has(t.id)) {
        dismissedIds.add(t.id);
        toast.dismiss(t.id);
      } else if (hasVisibleContent && dismissedIds.has(t.id)) {
        // If toast later gains content, allow it again
        dismissedIds.delete(t.id);
      }
    });
  }, [toasts]);

  // onMessageListener()
  //   .then((payload) => {
  //     
  //     if (window.localStorage.getItem("userToken")) {
  //       setOpen(true);
  //       setNotification(payload.notification);
  //       setNotificationData(payload.data);
  //     }
  //   })
  //   .catch((err) => console.log("failed: ", err));

  // useEffect(() => {
  //   if (isNotificationErr) {
  //     ReactDOM.render(
  //       <>
  //         <NotificationAllow />
  //       </>,
  //       document.getElementById("rootid")
  //     );
  //   }
  // }, [isNotificationErr]);

  return (
    <div className="App">
      <Toaster position="top-right" />
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Router history={history}>
            <AuthContext>
              <Notification />
              <div ref={myContainer} id="rootid"></div>
              {/* <NitificationPopUp
                data={notificationData}
                notification={notification}
                open={open}
                setOpen={setOpen}
              /> */}
              <UploadImageContext>
                <RenderRoutes data={routes} />
              </UploadImageContext>
            </AuthContext>
          </Router>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </div>
  );
}

function App() {
  return (
    <CreatorModeProvider>
      <AppContent />
    </CreatorModeProvider>
  );
}

export default App;

function RenderRoutes(props) {
  return (
    <Suspense fallback={<PageLoading />}>
      <Switch>
        {props.data.map((route, i) => {
          const Component = route.component;
          const Guard = route.guard ? AuthGuard : Fragment;
          const Layout = route.layout || Fragment;
          return (
            <Route
              exact={route.exact}
              key={i}
              path={route.path}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      <RenderRoutes data={route.routes} />
                    ) : (
                      <Component {...props} />
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
}
